import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { withRouter } from "react-router-dom";
import { Map, TileLayer, Polygon, Marker } from "react-leaflet";
import L from "leaflet";

import clientesService from "@services/clientes";
import zonesService from "@services/zones";
import segmentacaoService from "@services/segmentacao";

import Input from "@components/Input";
import Modal from "@components/Modal";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { NotificationManager } from "react-notifications";
import { MdAddCircleOutline, MdVisibility } from "react-icons/md";

// Components
import Menu from "@components/Menu";
import AutoComplete from "@components/AutoComplete";


import UserContext from "@components/context/userContext";
import { hasMenuPermission } from "@utils/permissions";

import New from "./new";

import { EventBus as eventBus } from "@components/EventBus";
import "./list.css";

class Page extends Component {
  static contextType = UserContext;

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    const customers = [{}];

    this.state = {
      loaded: false,
      customers,
      table: {
        columns: [], // Will be built dynamically based on permissions
        rows: [],
        loading: true,
      },
      currentPage: 1,
      itemsPerPage: 10,
      search: JSON.parse(localStorage.getItem("clientes.search")) || "",
      status: JSON.parse(localStorage.getItem("clientes.status")) || {
        value: "",
        label: "TODOS",
      },
      allStatus: [
        { value: "", label: "TODOS" },
        { value: "f", label: "ATIVOS" },
        { value: "t", label: "INATIVOS" },
      ],
      segmentacao: JSON.parse(localStorage.getItem("clientes.segmentacao")) || {
        value: "",
        label: "TODAS",
      },
      allSegmentacoes: [],
      zona: JSON.parse(localStorage.getItem("clientes.zona")) || {
        value: "",
        label: "TODAS",
      },
      allZonas: [],
      tooltip: {
        show: false,
        x: 0,
        y: 0,
        content: null,
        customer: null
      },
      zoneTooltip: {
        show: false,
        x: 0,
        y: 0,
        zone: null,
        customer: null
      },
      zones: [], // Store zones for display
      showImportModal: false,
      showMappingModal: false,
      csvColumns: [],
      csvData: [],
      csvSeparator: ';',
      columnMapping: {},
      selectedFile: null,
      codeConflicts: [],
      isDragging: false,
      autoMappedColumns: [],
      availableFields: [
        { value: '', label: 'Ignorar coluna' },
        { value: 'codigo', label: 'Código' },
        { value: 'nome_1', label: 'Nome' },
        { value: 'morada_1', label: 'Morada' },
        { value: 'morada_2', label: 'Localidade' },
        { value: 'codigo_postal', label: 'Código Postal' },
        { value: 'nif', label: 'NIF' },
        { value: 'telefone', label: 'Telefone' },
        { value: 'telemovel', label: 'Telemóvel' },
        { value: 'email', label: 'Email' },
        { value: 'inactivo', label: 'Inativo' },
      ],
    };
    this.loadFunction = this.loadFunction.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.uploadFunction = this.uploadFunction.bind(this);
    this.fileInputRef = React.createRef();
    this.handleImportClick = this.handleImportClick.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileSelect = this.handleFileSelect.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleMappingChange = this.handleMappingChange.bind(this);
    this.handleMappingConfirm = this.handleMappingConfirm.bind(this);
    this.handleMappingCancel = this.handleMappingCancel.bind(this);
    this.parseCSV = this.parseCSV.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.showZoneTooltip = this.showZoneTooltip.bind(this);
    this.hideZoneTooltip = this.hideZoneTooltip.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
  }

  // Function to determine if a color is dark
  isDarkColor(color) {
    if (!color) return false;
    
    // Convert rgb() to hex if needed
    let hexColor = color;
    if (color.startsWith('rgb(')) {
      const rgb = color.match(/\d+/g);
      if (rgb && rgb.length === 3) {
        const r = parseInt(rgb[0]);
        const g = parseInt(rgb[1]);
        const b = parseInt(rgb[2]);
        hexColor = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
      }
    }
    
    // Convert to hex if it starts with #
    if (hexColor.startsWith('#')) {
      const hex = hexColor.replace('#', '');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      
      // Calculate luminance
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5;
    }
    
    return false;
  }

  showTooltip(event, customer) {
    console.log('[DEBUG] showTooltip called:', {
      hasSegmentacoes: !!customer.segmentacoes,
      segmentacoesLength: customer.segmentacoes?.length,
      customer: customer.nome_1
    });
    
    if (!customer.segmentacoes || customer.segmentacoes.length <= 1) {
      console.log('[DEBUG] Tooltip not shown - not enough segmentations');
      return;
    }
    
    const rect = event.target.getBoundingClientRect();
    console.log('[DEBUG] Showing tooltip for:', customer.nome_1, 'with', customer.segmentacoes.length, 'segmentations');
    
    this.setState({
      tooltip: {
        show: true,
        x: rect.left + rect.width / 2,
        y: rect.top - 10,
        content: customer.segmentacoes,
        customer: customer
      }
    });
  }

  hideTooltip() {
    console.log('[DEBUG] hideTooltip called');
    this.setState({
      tooltip: {
        show: false,
        x: 0,
        y: 0,
        content: null,
        customer: null
      }
    });
  }

  showZoneTooltip(event, customer, zone) {
    if (!zone) return;
    
    const rect = event.target.getBoundingClientRect();
    this.setState({
      zoneTooltip: {
        show: true,
        x: rect.left + rect.width / 2,
        y: rect.top - 10,
        zone: zone,
        customer: customer
      }
    });
  }

  hideZoneTooltip() {
    this.setState({
      zoneTooltip: {
        show: false,
        x: 0,
        y: 0,
        zone: null,
        customer: null
      }
    });
  }

  getZoneBounds(zone) {
    if (!zone || !zone.coordinates || !Array.isArray(zone.coordinates)) {
      return {
        center: [39.5, -8.0], // Centro de Portugal como fallback
        bounds: [[39.0, -9.0], [40.0, -7.0]]
      };
    }
    
    const coordinates = zone.coordinates;
    let minLat = coordinates[0][0];
    let maxLat = coordinates[0][0];
    let minLng = coordinates[0][1];
    let maxLng = coordinates[0][1];
    
    coordinates.forEach(coord => {
      minLat = Math.min(minLat, coord[0]);
      maxLat = Math.max(maxLat, coord[0]);
      minLng = Math.min(minLng, coord[1]);
      maxLng = Math.max(maxLng, coord[1]);
    });
    
    const center = [(minLat + maxLat) / 2, (minLng + maxLng) / 2];
    const bounds = [[minLat, minLng], [maxLat, maxLng]];
    
    return { center, bounds };
  }

  async loadFunction() {
    const profile = this.context;

    if (!this.state.loaded) {
      const { history } = this.props;

      const customers = await clientesService.get(profile.idEmpresa);

      // Check if user has permission to view segmentations and zones
      const hasSegmentacaoPermission = hasMenuPermission('config:segmentacao', profile);
      const hasZonesPermission = hasMenuPermission('config:zones', profile);

      // Load zones if user has permission
      let zones = [];
      let allZonas = [{ value: "", label: "TODAS" }];
      if (hasZonesPermission) {
        try {
          const zonesResponse = await zonesService.getZones(profile.idEmpresa);
          
          // Handle different response structures
          if (Array.isArray(zonesResponse)) {
            zones = zonesResponse;
          } else if (zonesResponse && Array.isArray(zonesResponse.data)) {
            zones = zonesResponse.data;
          } else if (zonesResponse && zonesResponse.zones && Array.isArray(zonesResponse.zones)) {
            zones = zonesResponse.zones;
          } else {
            zones = [];
          }

          // Build zones options for filter
          allZonas = [
            { value: "", label: "TODAS" },
            ...zones.map(zone => ({
              value: zone.id || zone.idzona || "",
              label: zone.name || zone.nome || `Zona ${zone.id || zone.idzona}`
            }))
          ];
        } catch (error) {
          console.error('Erro ao carregar zonas:', error);
        }
      }

      // Load segmentations if user has permission
      let allSegmentacoes = [{ value: "", label: "TODAS" }];
      if (hasSegmentacaoPermission) {
        try {
          const segmentacoesResponse = await segmentacaoService.get(profile.idEmpresa);
          const segmentacoes = Array.isArray(segmentacoesResponse) ? segmentacoesResponse : [];
          
          // Build segmentations options for filter
          allSegmentacoes = [
            { value: "", label: "TODAS" },
            ...segmentacoes.map(seg => ({
              value: seg.idsegmentacao || "",
              label: seg.nome || `Segmentação ${seg.idsegmentacao}`
            }))
          ];
        } catch (error) {
          console.error('Erro ao carregar segmentações:', error);
        }
      }

      const enrichedCustomers = customers.map((customer) => ({
        ...customer,
        inativo: customer.inactivo === 't' ? 't' : 'f',
        //gdpr: customer.gdpr === "t" ? "TRUE" : "FALSE",
        // Store original segmentacoes array for filtering
        segmentacoesData: customer.segmentacoes && Array.isArray(customer.segmentacoes) ? customer.segmentacoes : [],
        view: (
          <MdVisibility
            style={{ fontSize: "15px", cursor: "pointer" }}
            onClick={() =>
              history.push(`/clientes/${customer.codigo}`)
            }
          />
        ),
        ...(hasSegmentacaoPermission && {
          segmentacoes: customer.segmentacoes && Array.isArray(customer.segmentacoes) && customer.segmentacoes.length > 0
            ? (() => {
                const segmentacoes = customer.segmentacoes;
                const visibleCount = 1;
                const visibleSegs = segmentacoes.slice(0, visibleCount);
                const remainingCount = segmentacoes.length - visibleCount;
                
                return (
                  <div 
                    style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '2px' }}
                    onMouseEnter={(e) => this.showTooltip(e, customer)}
                    onMouseLeave={this.hideTooltip}
                  >
                    {visibleSegs.map((seg, index) => (
                      <span
                        key={index}
                        style={{
                          display: 'inline-block',
                          backgroundColor: seg.color || '#e5e7eb',
                          color: seg.color && this.isDarkColor(seg.color) ? '#ffffff' : '#000000',
                          padding: '2px 8px',
                          borderRadius: '12px',
                          fontSize: '11px',
                          fontWeight: '500'
                        }}
                      >
                        {seg.nome || `Segmentação ${seg.idsegmentacao}`}
                      </span>
                    ))}
                    {remainingCount > 0 && (
                      <span
                        style={{
                          display: 'inline-block',
                          backgroundColor: '#6b7280',
                          color: '#ffffff',
                          padding: '2px 8px',
                          borderRadius: '12px',
                          fontSize: '11px',
                          fontWeight: '500',
                          cursor: 'pointer'
                        }}
                      >
                        +{remainingCount}
                      </span>
                    )}
                  </div>
                );
              })()
            : <span style={{ color: '#6b7280', fontStyle: 'italic' }}>Nenhuma</span>
        }),
        ...(hasZonesPermission && {
          zona: customer.zona_id ? (() => {
            if (!zones || !Array.isArray(zones)) {
              return <span style={{ color: '#6b7280', fontStyle: 'italic' }}>Carregando...</span>;
            }
            const zone = zones.find(z => z.id === customer.zona_id || z.id === parseInt(customer.zona_id));
            if (!zone) {
              return <span style={{ color: '#6b7280', fontStyle: 'italic' }}>Zona não encontrada</span>;
            }
            
            // Get zone color (handle both string and object formats)
            let zoneColor = '#e5e7eb';
            if (zone.color) {
              if (typeof zone.color === 'string') {
                zoneColor = zone.color;
              } else if (zone.color.fill) {
                zoneColor = zone.color.fill;
              }
            }
            
            return (
              <span
                style={{
                  display: 'inline-block',
                  backgroundColor: zoneColor,
                  color: this.isDarkColor(zoneColor) ? '#ffffff' : '#000000',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  fontSize: '11px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => this.showZoneTooltip(e, customer, zone)}
                onMouseLeave={this.hideZoneTooltip}
              >
                {zone.name}
              </span>
            );
          })() : <span style={{ color: '#6b7280', fontStyle: 'italic' }}>Nenhuma</span>
        })
      }));

      enrichedCustomers.unshift({
        codigo: 'CF',
        nome_1: 'Consumidor Final',
        inativo: 'f',
        segmentacoesData: [],
        zona_id: null,
        ...(hasSegmentacaoPermission && {
          segmentacoes: '-'
        }),
        ...(hasZonesPermission && {
          zona: '-'
        }),
        view: (
          <MdVisibility
            style={{ fontSize: "15px", cursor: "pointer" }}
            onClick={() =>
              history.push(`/clientes/CF`)
            }
          />
        ),
      });

      // Build columns dynamically based on permissions
      const baseColumns = [
        {
          Header: "Codigo",
          accessor: "codigo",
        },
        {
          Header: "Nome 1",
          accessor: "nome_1",
        },
        {
          Header: "Morada 1",
          accessor: "morada_1",
        },
        {
          Header: "Telefone",
          accessor: "telefone",
        },
        {
          Header: "Telemovel",
          accessor: "telemovel",
        },
        {
          Header: "Email",
          accessor: "email",
        },
      ];

      // Add segmentations column only if user has permission
      if (hasSegmentacaoPermission) {
        baseColumns.push({
          Header: "Segmentações",
          accessor: "segmentacoes",
          style: { maxWidth: "200px", wordWrap: "break-word" },
        });
      }

      // Add zones column only if user has permission
      if (hasZonesPermission) {
        baseColumns.push({
          Header: "Localização",
          accessor: "zona",
          style: { maxWidth: "150px", wordWrap: "break-word" },
        });
      }

      baseColumns.push(
        {
          Header: 'Estado',
          id: 'inativo',
          accessor: d => d.inativo === 't' ? (
            <span className="badge badge-danger">INATIVO</span>
          ) : (
            <span className="badge badge-success">ATIVO</span>
          ),
        },
        {
          Header: "",
          accessor: "view",
        }
      );

      this.setState({
        table: {
          ...this.state.table,
          columns: baseColumns,
          rows: enrichedCustomers,
          loading: false,
        },
        zones: zones, // Store zones for future use
        allSegmentacoes: allSegmentacoes,
        allZonas: allZonas,
        loaded: true,
      });
    }
  }

  async removeFunction(data) {
    const profile = this.context;

    confirmAlert({
      title: "Confirmação",
      message: `Tem a certeza que deseja apagar o cliente ${data.name}?`,
      buttons: [
        {
          label: "Sim",
          onClick: async () => {
            try {
              const response = await clientesService.unset(profile.idEmpresa, data.codigo);
              if (response !== "NOK") {
                this.setState({
                  customers: this.state.customers.filter(
                    (client) => client.codigo !== data.codigo
                  ),
                });
              }
            } catch (error) {
              console.error(error);
            }
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  }

  filterData(searchTerm) {
    this.setState({ search: searchTerm, currentPage: 1 }, () => {
      localStorage.setItem('clientes.search', JSON.stringify(searchTerm));
    });
  }

  handlePageChange(page) {
    this.setState({ currentPage: page });
  }

  handleItemsPerPageChange(e) {
    this.setState({ 
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1 
    });
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;

    // Reset page when filter changes
    const shouldResetPage = ["status", "segmentacao", "zona"].includes(name);

    this.setState({
      [name]: value,
      ...(shouldResetPage && { currentPage: 1 })
    }, () => {
        switch (name) {
            case "search":
            case "status":
            case "segmentacao":
            case "zona":
                localStorage.setItem(`clientes.${name}`, JSON.stringify(value));
                break;
            default:
                break;
            }
    });
  }

  async uploadFunction() {
    confirmAlert({
      title: "Confirmação",
      message: `Tem a certeza que deseja enviar todos os clientes para o Apollo?`,
      buttons: [
        {
          label: "Sim",
          onClick: async () => {
            const profile = this.context;
            try {
              await clientesService.export(profile.idEmpresa);
            } catch (error) {
              console.error(error);
            }
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  }

  handleImportClick() {
    // Mostrar modal de seleção de ficheiro
    this.setState({ showImportModal: true });
  }

  handleFileSelect() {
    // Abrir file input
    this.fileInputRef.current.value = null;
    this.fileInputRef.current.click();
  }

  handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: true });
  }

  handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: false });
  }

  handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragging: false });

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        this.processFile(file);
      } else {
        NotificationManager.error('Por favor, selecione um ficheiro CSV válido', "Erro", 5000);
      }
    }
  }

  processFile(file) {
    // Fechar modal de importação
    this.setState({ showImportModal: false });

    // Ler o ficheiro CSV
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const csvText = e.target.result;
        const { columns, data, separator } = this.parseCSV(csvText);
        
        // Inicializar mapeamento e pré-selecionar colunas com nomes correspondentes
        const columnMapping = {};
        const autoMappedColumns = [];
        
        columns.forEach(col => {
          // Normalizar nome da coluna (trim e lowercase para comparação)
          const normalizedCol = col.trim().toLowerCase();
          
          // Verificar se existe um campo disponível com o mesmo nome
          const matchedField = this.state.availableFields.find(field => {
            if (!field.value || field.value === '') return false;
            return field.value.toLowerCase() === normalizedCol || 
                   field.label.toLowerCase() === normalizedCol;
          });
          
          if (matchedField && matchedField.value) {
            // Pré-selecionar se encontrar correspondência
            columnMapping[col] = matchedField.value;
            autoMappedColumns.push(col);
          } else {
            // Deixar vazio se não encontrar correspondência
            columnMapping[col] = '';
          }
        });

        // Verificar conflitos iniciais se já houver mapeamento de código
        const initialConflicts = [];
        const hasCodigoInMapping = Object.values(columnMapping).includes('codigo');
        if (hasCodigoInMapping) {
          const conflicts = this.checkCodeConflicts(columnMapping, data);
          initialConflicts.push(...conflicts);
        }
        
        this.setState({
          selectedFile: file,
          csvColumns: columns,
          csvData: data,
          csvSeparator: separator,
          columnMapping: columnMapping,
          autoMappedColumns: autoMappedColumns,
          showMappingModal: true,
          codeConflicts: initialConflicts,
        });
      } catch (error) {
        NotificationManager.error('Erro ao ler o ficheiro CSV', "Erro", 5000);
        console.error(error);
      }
    };
    reader.readAsText(file, 'UTF-8');
  }

  parseCSV(text) {
    const lines = text.split(/\r?\n/);
    if (lines.length === 0) return { columns: [], data: [], separator: ',' };

    // Detectar separador (ponto e vírgula ou vírgula)
    const firstLine = lines[0];
    const separator = firstLine.includes(';') ? ';' : ',';

    // Função para dividir CSV respeitando valores entre aspas
    const splitCSVLine = (line, sep) => {
      const result = [];
      let current = '';
      let insideQuotes = false;
      
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        
        if (char === '"') {
          if (insideQuotes && line[i + 1] === '"') {
            // Aspas duplas escapadas
            current += '"';
            i++; // Pular próxima aspas
          } else {
            // Toggle quotes
            insideQuotes = !insideQuotes;
          }
        } else if (char === sep && !insideQuotes) {
          // Separador fora de aspas
          result.push(current);
          current = '';
        } else {
          current += char;
        }
      }
      
      // Adicionar último campo
      result.push(current);
      return result;
    };

    // Função para limpar valores (remover aspas externas e espaços)
    const cleanValue = (value) => {
      if (!value) return '';
      let cleaned = value.trim();
      // Remover aspas apenas se envolverem todo o valor
      if ((cleaned.startsWith('"') && cleaned.endsWith('"')) || 
          (cleaned.startsWith("'") && cleaned.endsWith("'"))) {
        cleaned = cleaned.slice(1, -1);
      }
      // Substituir aspas duplas escapadas por aspas simples
      cleaned = cleaned.replace(/""/g, '"');
      return cleaned.trim();
    };

    // Primeira linha são os headers
    const headerParts = splitCSVLine(firstLine, separator);
    const headers = headerParts.map(cleanValue);
    
    // Resto são os dados
    const data = [];
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;
      
      const values = splitCSVLine(line, separator).map(cleanValue);
      if (values.length === 0 || values.every(v => !v)) continue;
      
      const row = {};
      headers.forEach((header, index) => {
        row[header] = values[index] || '';
      });
      data.push(row);
    }

    return { columns: headers, data, separator };
  }

  stringifyCSV(data, headers, separator = ';') {
    // Função para formatar valores CSV com aspas duplas obrigatórias
    const formatCSVValue = (value) => {
      if (value === null || value === undefined) return '""';
      const str = String(value);
      // Escapar aspas duplas internas ("" para representar uma aspas dentro de um valor entre aspas)
      const escaped = str.replace(/"/g, '""');
      // Sempre envolver em aspas duplas
      return `"${escaped}"`;
    };

    // Criar header com formato específico: "codigo";"nome_1";"morada_1"
    const headerLine = headers.map(formatCSVValue).join(separator);

    // Criar linhas de dados com o mesmo formato
    const dataLines = data.map(row => 
      headers.map(header => formatCSVValue(row[header] || '')).join(separator)
    );

    // Combinar tudo
    return [headerLine, ...dataLines].join('\n');
  }

  reorganizeCSV(csvData, columnMapping) {
    // Criar novo array de dados com campos reorganizados
    const reorganizedData = csvData.map(row => {
      const newRow = {};
      
      // Para cada campo mapeado, copiar o valor do CSV original
      Object.keys(columnMapping).forEach(csvColumn => {
        const mappedField = columnMapping[csvColumn];
        if (mappedField && mappedField !== '') {
          // Usar o nome do campo como chave no novo CSV
          newRow[mappedField] = row[csvColumn] || '';
        }
      });
      
      return newRow;
    });

    // Criar headers baseados nos campos mapeados (apenas os que não são "Ignorar coluna")
    const headers = Object.values(columnMapping)
      .filter(field => field && field !== '')
      .filter((field, index, self) => self.indexOf(field) === index); // Remover duplicados

    return { data: reorganizedData, headers };
  }

  createCSVFile(csvContent, fileName = 'import.csv') {
    // Criar um Blob com o conteúdo CSV
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    
    // Criar um File a partir do Blob
    const file = new File([blob], fileName, { 
      type: 'text/csv;charset=utf-8;',
      lastModified: Date.now()
    });
    
    return file;
  }

  async handleFileChange(event) {
    const file = event.target.files[0];
    if (!file) return;

    // Fechar modal de importação se estiver aberto
    if (this.state.showImportModal) {
      this.setState({ showImportModal: false });
    }

    // Processar ficheiro
    this.processFile(file);
  }

  checkCodeConflicts(columnMapping, csvData) {
    // Verificar se o campo 'codigo' está mapeado
    const codigoColumn = Object.keys(columnMapping).find(col => columnMapping[col] === 'codigo');
    if (!codigoColumn) {
      return [];
    }

    // Obter todos os códigos existentes na página
    const existingCodes = new Set(
      this.state.table.rows.map(customer => String(customer.codigo || '').trim()).filter(code => code)
    );

    // Verificar conflitos no CSV
    const conflicts = [];
    csvData.forEach((row, index) => {
      const csvCode = String(row[codigoColumn] || '').trim();
      if (csvCode && existingCodes.has(csvCode)) {
        conflicts.push({
          line: index + 2, // +2 porque linha 1 é o header e index começa em 0
          code: csvCode,
          row: row
        });
      }
    });

    return conflicts;
  }

  handleMappingChange(columnName, fieldValue) {
    this.setState(prevState => {
      const newMapping = {
        ...prevState.columnMapping,
        [columnName]: fieldValue,
      };
      
      // Verificar conflitos quando o mapeamento muda
      const conflicts = this.checkCodeConflicts(newMapping, prevState.csvData);
      
      return {
        columnMapping: newMapping,
        codeConflicts: conflicts,
      };
    });
  }

  handleMappingCancel() {
    this.setState({
      showMappingModal: false,
      csvColumns: [],
      csvData: [],
      csvSeparator: ';',
      columnMapping: {},
      selectedFile: null,
      codeConflicts: [],
      autoMappedColumns: [],
    });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
  }

  async handleMappingConfirm() {
    const { selectedFile, codeConflicts, columnMapping } = this.state;
    if (!selectedFile) return;

    // Verificar se o campo 'nome_1' (nome) está mapeado - OBRIGATÓRIO
    const nomeColumn = Object.keys(columnMapping).find(col => columnMapping[col] === 'nome_1');
    const hasNomeMapped = !!nomeColumn;

    // Se não houver nome mapeado, mostrar erro
    if (!hasNomeMapped) {
      confirmAlert({
        title: "Campo Obrigatório",
        message: (
          <div>
            <p style={{ color: "#d32f2f", fontWeight: "bold" }}>
              É obrigatório mapear pelo menos uma coluna para o campo <strong>Nome</strong>.
            </p>
            <p style={{ marginTop: "10px" }}>
              Por favor, selecione uma coluna do CSV para o campo "Nome" antes de continuar.
            </p>
          </div>
        ),
        buttons: [
          {
            label: "OK",
            onClick: () => {},
          },
        ],
      });
      return;
    }

    // Verificar se o campo 'codigo' está mapeado
    const codigoColumn = Object.keys(columnMapping).find(col => columnMapping[col] === 'codigo');
    const hasCodigoMapped = !!codigoColumn;

    // Se não houver código mapeado, informar o utilizador
    if (!hasCodigoMapped) {
      confirmAlert({
        title: "Código não Mapeado",
        message: (
          <div>
            <p>Nenhuma coluna foi mapeada para o campo <strong>Código</strong>.</p>
            <p style={{ marginTop: "10px" }}>
              Todos os clientes do CSV serão <strong>adicionados como novos</strong> com códigos gerados automaticamente, 
              seguindo a sequência atualmente existente na base de dados.
            </p>
            <p style={{ marginTop: "10px" }}>
              Deseja continuar com a importação?
            </p>
          </div>
        ),
        buttons: [
          {
            label: "Sim, continuar",
            onClick: () => {
              // Se houver conflitos, mostrar confirmação de conflitos também
              if (codeConflicts.length > 0) {
                this.showConflictsConfirmation();
              } else {
                this.performImport();
              }
            },
          },
          {
            label: "Cancelar",
            onClick: () => {},
          },
        ],
      });
      return;
    }

    // Se houver conflitos, pedir confirmação
    if (codeConflicts.length > 0) {
      confirmAlert({
        title: "Conflitos de Código Detectados",
        message: (
          <div>
            <p>Encontrados <strong>{codeConflicts.length}</strong> conflito(s) de código:</p>
            <div style={{ 
              maxHeight: "200px", 
              overflow: "auto", 
              marginTop: "10px",
              padding: "10px",
              backgroundColor: "#f8f9fa",
              borderRadius: "4px",
              fontSize: "12px"
            }}>
              {codeConflicts.map((conflict, index) => (
                <div key={index} style={{ marginBottom: "5px" }}>
                  <strong>Linha {conflict.line}:</strong> Código <code>{conflict.code}</code>
                </div>
              ))}
            </div>
            <p style={{ marginTop: "10px" }}>Estes registos serão <strong>atualizados</strong> se continuar.</p>
            <p>Deseja continuar com a importação?</p>
          </div>
        ),
        buttons: [
          {
            label: "Sim, continuar",
            onClick: () => this.performImport(),
          },
          {
            label: "Cancelar",
            onClick: () => {},
          },
        ],
      });
      return;
    }

    // Se não houver conflitos, importar diretamente
    this.performImport();
  }

  showConflictsConfirmation() {
    const { codeConflicts } = this.state;
    confirmAlert({
      title: "Conflitos de Código Detectados",
      message: (
        <div>
          <p>Encontrados <strong>{codeConflicts.length}</strong> conflito(s) de código:</p>
          <div style={{ 
            maxHeight: "200px", 
            overflow: "auto", 
            marginTop: "10px",
            padding: "10px",
            backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            fontSize: "12px"
          }}>
            {codeConflicts.map((conflict, index) => (
              <div key={index} style={{ marginBottom: "5px" }}>
                <strong>Linha {conflict.line}:</strong> Código <code>{conflict.code}</code>
              </div>
            ))}
          </div>
          <p style={{ marginTop: "10px" }}>Estes registos serão <strong>atualizados</strong> se continuar.</p>
          <p>Deseja continuar com a importação?</p>
        </div>
      ),
      buttons: [
        {
          label: "Sim, continuar",
          onClick: () => this.performImport(),
        },
        {
          label: "Cancelar",
          onClick: () => {},
        },
      ],
    });
  }

  async performImport() {
    const { csvData, columnMapping } = this.state;
    if (!csvData || csvData.length === 0) return;

    const profile = this.context;

    // Reorganizar CSV baseado no mapeamento
    const { data: reorganizedData, headers } = this.reorganizeCSV(csvData, columnMapping);

    // Gerar CSV corrigido com formato específico: ponto e vírgula e aspas duplas
    const correctedCSV = this.stringifyCSV(reorganizedData, headers, ';');

    // Criar novo ficheiro CSV corrigido
    const correctedFile = this.createCSVFile(correctedCSV, 'import_corrected.csv');

    // Criar FormData com o ficheiro corrigido
    const formData = new FormData();
    formData.append('idempresa', profile.idEmpresa);
    formData.append('file', correctedFile);

    this.setState({ showMappingModal: false });

    try {
      const response = await clientesService.import(formData);
      if (response.imported) {
        NotificationManager.success(`${response.imported} cliente(s)`, "Importação de Clientes", 5000);
      } else if (response.error) {
        NotificationManager.error(`Erro: ${response.error}`, "Erro", 5000);
      } else if (response === 'NOK') {
        NotificationManager.error('Erro ao importar clientes', "Erro", 5000);
      } else {
        NotificationManager.info('Importação concluída.', "Importação de Clientes", 5000);
      }
      // Reload customers list
      this.setState({ loaded: false }, () => {
        this.loadFunction();
      });
    } catch (error) {
      NotificationManager.error('Erro ao importar clientes', "Erro", 5000);
      console.error(error);
    }

    // Reset state
    this.setState({
      csvColumns: [],
      csvData: [],
      csvSeparator: ';',
      columnMapping: {},
      selectedFile: null,
      codeConflicts: [],
      autoMappedColumns: [],
    });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
  }

  render() {
    const { table, search, status, allStatus, segmentacao, allSegmentacoes, zona, allZonas, tooltip, zoneTooltip, showImportModal, showMappingModal, csvColumns, csvData, columnMapping, availableFields, codeConflicts, isDragging, currentPage, itemsPerPage } = this.state;
    const { location, history } = this.props;
    const cookies = new URLSearchParams(location.search);

    const filterSearch = search.split(" ");

    const oneOfAll = (customer, search) => {
      const keys = Object.keys(customer);
      return keys.some((key) => `${customer[key] || ''}`.toLowerCase().includes(search.toLowerCase()))
    }

    const filteredCustomers = table.rows.length
      ? table.rows.filter((customer) =>
          filterSearch.every(
            (eachSearch) =>
              eachSearch === "" ||
              oneOfAll(customer, eachSearch)
          )
        ).filter((customer) =>
          status.value !== ''
            ? customer.inativo === status.value
            : true
        ).filter((customer) => {
          // Filter by segmentação
          if (segmentacao.value !== '') {
            if (!customer.segmentacoesData || !Array.isArray(customer.segmentacoesData) || customer.segmentacoesData.length === 0) {
              return false;
            }
            const hasSegmentacao = customer.segmentacoesData.some(seg => 
              String(seg.idsegmentacao || '') === String(segmentacao.value)
            );
            if (!hasSegmentacao) return false;
          }
          
          // Filter by zona
          if (zona.value !== '') {
            const customerZonaId = customer.zona_id || null;
            if (String(customerZonaId || '') !== String(zona.value)) {
              return false;
            }
          }
          
          return true;
        })
      : [];

    // Calcular estatísticas
    const totalCustomers = table.rows.length;
    const activeCustomers = table.rows.filter(customer => customer.inativo !== 't').length;
    const inactiveCustomers = table.rows.filter(customer => customer.inativo === 't').length;
    const filteredCount = filteredCustomers.length;

    // Calcular estatísticas de zonas e segmentações
    const { zones } = this.state;
    const hasZonesPermission = hasMenuPermission('config:zones', this.context);
    const hasSegmentacaoPermission = hasMenuPermission('config:segmentacao', this.context);

    // Contar clientes por zona
    let zonaComMaisClientes = null;
    let zonaComMenosClientes = null;
    if (hasZonesPermission && zones && zones.length > 0) {
      const clientesPorZona = {};
      table.rows.forEach(customer => {
        if (customer.zona_id) {
          const zonaId = String(customer.zona_id);
          clientesPorZona[zonaId] = (clientesPorZona[zonaId] || 0) + 1;
        }
      });

      const zonasComClientes = Object.entries(clientesPorZona)
        .map(([zonaId, count]) => {
          const zone = zones.find(z => String(z.id || z.idzona) === zonaId);
          return {
            zonaId,
            count,
            name: zone ? (zone.name || zone.nome || `Zona ${zonaId}`) : `Zona ${zonaId}`
          };
        })
        .filter(z => z.count > 0)
        .sort((a, b) => b.count - a.count);

      if (zonasComClientes.length > 0) {
        zonaComMaisClientes = zonasComClientes[0];
        zonaComMenosClientes = zonasComClientes[zonasComClientes.length - 1];
      }
    }

    // Contar clientes por segmentação
    let segmentacaoComMaisClientes = null;
    let segmentacaoComMenosClientes = null;
    if (hasSegmentacaoPermission && this.state.allSegmentacoes && this.state.allSegmentacoes.length > 1) {
      const segmentacoesComId = this.state.allSegmentacoes.filter(seg => seg.value !== '');
      const clientesPorSegmentacao = {};
      
      table.rows.forEach(customer => {
        if (customer.segmentacoesData && Array.isArray(customer.segmentacoesData) && customer.segmentacoesData.length > 0) {
          customer.segmentacoesData.forEach(seg => {
            const segId = String(seg.idsegmentacao || '');
            if (segId) {
              clientesPorSegmentacao[segId] = (clientesPorSegmentacao[segId] || 0) + 1;
            }
          });
        }
      });

      const segmentacoesComClientes = Object.entries(clientesPorSegmentacao)
        .map(([segId, count]) => {
          const seg = segmentacoesComId.find(s => String(s.value) === segId);
          return {
            segId,
            count,
            name: seg ? seg.label : `Segmentação ${segId}`
          };
        })
        .filter(s => s.count > 0)
        .sort((a, b) => b.count - a.count);

      if (segmentacoesComClientes.length > 0) {
        segmentacaoComMaisClientes = segmentacoesComClientes[0];
        segmentacaoComMenosClientes = segmentacoesComClientes[segmentacoesComClientes.length - 1];
      }
    }

    // Paginação
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedCustomers = filteredCustomers.slice(startIndex, endIndex);

    return  (
      <div className="clientes-list-page">
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-xs-12">
            <ol
              style={{
                textAlign: "left",
                marginTop: "75px",
              }}
              className="breadcrumb"
            >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li className="active">Clientes (beta)</li>
            </ol>
          </div>
        </div>
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-sm-12" style={{ textAlign: "center" }}>
            {/* Secção de Estatísticas */}
            <div className="clientes-stats-section">
              <div className="clientes-stats-grid">
                <div className="clientes-stat-card">
                  <div className="clientes-stat-icon">
                    <i className="fas fa-users"></i>
                </div>
                  <div className="clientes-stat-content">
                    <div className="clientes-stat-label">Total de Clientes</div>
                    <div className="clientes-stat-value">{totalCustomers}</div>
                  </div>
                </div>
                <div className="clientes-stat-card clientes-stat-card-success">
                  <div className="clientes-stat-icon">
                    <i className="fas fa-check-circle"></i>
                  </div>
                  <div className="clientes-stat-content">
                    <div className="clientes-stat-label">Clientes Ativos</div>
                    <div className="clientes-stat-value">{activeCustomers}</div>
                  </div>
                </div>
                <div className="clientes-stat-card clientes-stat-card-danger">
                  <div className="clientes-stat-icon">
                    <i className="fas fa-times-circle"></i>
                  </div>
                  <div className="clientes-stat-content">
                    <div className="clientes-stat-label">Clientes Inativos</div>
                    <div className="clientes-stat-value">{inactiveCustomers}</div>
                  </div>
                </div>
                <div className="clientes-stat-card clientes-stat-card-info">
                  <div className="clientes-stat-icon">
                    <i className="fas fa-filter"></i>
                  </div>
                  <div className="clientes-stat-content">
                    <div className="clientes-stat-label">Resultados Filtrados</div>
                    <div className="clientes-stat-value">{filteredCount}</div>
                  </div>
                </div>
                {/* Estatísticas de Zonas */}
                {hasZonesPermission && (
                  <>
                    <div className="clientes-stat-card">
                      <div className="clientes-stat-icon" style={zonaComMaisClientes ? { backgroundColor: '#fff3cd', color: '#856404' } : {}}>
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                      <div className="clientes-stat-content">
                        <div className="clientes-stat-label">Zona com Mais Clientes</div>
                        {zonaComMaisClientes ? (
                          <>
                            <div 
                              className="clientes-stat-value" 
                              style={{ 
                                fontSize: '14px', 
                                color: '#856404',
                                cursor: 'pointer',
                                display: 'inline-block'
                              }}
                              onMouseEnter={(e) => {
                                const zone = zones.find(z => String(z.id || z.idzona) === zonaComMaisClientes.zonaId);
                                if (zone) {
                                  this.showZoneTooltip(e, null, zone);
                                }
                              }}
                              onMouseLeave={this.hideZoneTooltip}
                            >
                              {zonaComMaisClientes.name}
                            </div>
                            <div style={{ fontSize: '12px', color: '#856404', marginTop: '4px' }}>
                              {zonaComMaisClientes.count} cliente{zonaComMaisClientes.count !== 1 ? 's' : ''}
                            </div>
                          </>
                        ) : (
                          <div className="clientes-stat-value" style={{ fontSize: '14px' }}>
                            -
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="clientes-stat-card">
                      <div className="clientes-stat-icon" style={zonaComMenosClientes && zonaComMenosClientes.zonaId !== zonaComMaisClientes?.zonaId ? { backgroundColor: '#d1ecf1', color: '#0c5460' } : {}}>
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                      <div className="clientes-stat-content">
                        <div className="clientes-stat-label">Zona com Menos Clientes</div>
                        {zonaComMenosClientes && zonaComMenosClientes.zonaId !== zonaComMaisClientes?.zonaId ? (
                          <>
                            <div 
                              className="clientes-stat-value" 
                              style={{ 
                                fontSize: '14px', 
                                color: '#0c5460',
                                cursor: 'pointer',
                                display: 'inline-block'
                              }}
                              onMouseEnter={(e) => {
                                const zone = zones.find(z => String(z.id || z.idzona) === zonaComMenosClientes.zonaId);
                                if (zone) {
                                  this.showZoneTooltip(e, null, zone);
                                }
                              }}
                              onMouseLeave={this.hideZoneTooltip}
                            >
                              {zonaComMenosClientes.name}
                            </div>
                            <div style={{ fontSize: '12px', color: '#0c5460', marginTop: '4px' }}>
                              {zonaComMenosClientes.count} cliente{zonaComMenosClientes.count !== 1 ? 's' : ''}
                            </div>
                          </>
                        ) : (
                          <div className="clientes-stat-value" style={{ fontSize: '14px' }}>
                            -
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* Estatísticas de Segmentações */}
                {hasSegmentacaoPermission && (
                  <>
                    <div className="clientes-stat-card">
                      <div className="clientes-stat-icon" style={segmentacaoComMaisClientes ? { backgroundColor: '#d4edda', color: '#155724' } : {}}>
                        <i className="fas fa-tags"></i>
                      </div>
                      <div className="clientes-stat-content">
                        <div className="clientes-stat-label">Segmentação com Mais Clientes</div>
                        {segmentacaoComMaisClientes ? (
                          <>
                            <div className="clientes-stat-value" style={{ fontSize: '14px', color: '#155724' }}>
                              {segmentacaoComMaisClientes.name}
                            </div>
                            <div style={{ fontSize: '12px', color: '#155724', marginTop: '4px' }}>
                              {segmentacaoComMaisClientes.count} cliente{segmentacaoComMaisClientes.count !== 1 ? 's' : ''}
                            </div>
                          </>
                        ) : (
                          <div className="clientes-stat-value" style={{ fontSize: '14px' }}>
                            -
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="clientes-stat-card">
                      <div className="clientes-stat-icon" style={segmentacaoComMenosClientes && segmentacaoComMenosClientes.segId !== segmentacaoComMaisClientes?.segId ? { backgroundColor: '#f8d7da', color: '#721c24' } : {}}>
                        <i className="fas fa-tags"></i>
                      </div>
                      <div className="clientes-stat-content">
                        <div className="clientes-stat-label">Segmentação com Menos Clientes</div>
                        {segmentacaoComMenosClientes && segmentacaoComMenosClientes.segId !== segmentacaoComMaisClientes?.segId ? (
                          <>
                            <div className="clientes-stat-value" style={{ fontSize: '14px', color: '#721c24' }}>
                              {segmentacaoComMenosClientes.name}
                            </div>
                            <div style={{ fontSize: '12px', color: '#721c24', marginTop: '4px' }}>
                              {segmentacaoComMenosClientes.count} cliente{segmentacaoComMenosClientes.count !== 1 ? 's' : ''}
                            </div>
                          </>
                        ) : (
                          <div className="clientes-stat-value" style={{ fontSize: '14px' }}>
                            -
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            
            <div className="clientes-filters-section">
                <div className="clientes-filters-section-title">
                  <div className="clientes-filters-title-left">
                    <i className="fas fa-filter"></i>
                    <span>Filtros</span>
                  </div>
                  <div className="clientes-header-actions">
                    <button
                      className="clientes-header-btn"
                    onClick={this.uploadFunction}
                      title="Enviar Clientes"
                  >
                        <i className="fas fa-upload"></i>
                      <span>Enviar Clientes</span>
                    </button>
                    <button
                      className="clientes-header-btn"
                    onClick={this.handleImportClick}
                      title="Importar Clientes"
                  >
                        <i className="fas fa-file-import"></i>
                      <span>Importar Clientes</span>
                    </button>
                    <button
                      className="clientes-header-btn clientes-header-btn-primary"
                      onClick={() => eventBus.$emit("Modal-newcustomer", { header: "Criar cliente", body: <New /> })}
                      title="Adicionar Cliente"
                    >
                      <MdAddCircleOutline />
                      <span>Adicionar Cliente</span>
                    </button>
                  </div>
                </div>
                  <input
                    type="file"
                    accept=".csv"
                    ref={this.fileInputRef}
                    style={{ display: "none" }}
                    onChange={this.handleFileChange}
                  />
                {/* Modal de seleção de ficheiro CSV */}
                  {showImportModal && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.3)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    onClick={(e) => {
                      if (e.target === e.currentTarget) {
                        this.setState({ showImportModal: false, isDragging: false });
                      }
                    }}
                    >
                      <div
                        style={{
                          background: "#fff",
                        padding: 30,
                          borderRadius: 8,
                        minWidth: 500,
                        maxWidth: "90vw",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
                        }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h4 style={{ marginTop: 0, marginBottom: 20 }}>Importar Clientes</h4>
                      <p style={{ fontSize: "14px", color: "#666", marginBottom: 20 }}>
                        Selecione um ficheiro CSV para importar os clientes. Pode arrastar e soltar o ficheiro ou clicar para selecionar.
                      </p>
                      <div
                        onDragOver={this.handleDragOver}
                        onDragLeave={this.handleDragLeave}
                        onDrop={this.handleDrop}
                        onClick={this.handleFileSelect}
                        style={{
                          border: `2px dashed ${isDragging ? '#007bff' : '#ddd'}`,
                          borderRadius: 8,
                          padding: 40,
                          textAlign: "center",
                          backgroundColor: isDragging ? '#f0f8ff' : '#fafafa',
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          marginBottom: 20
                        }}
                      >
                        <i 
                          className="fas fa-cloud-upload-alt" 
                          style={{ 
                            fontSize: "48px", 
                            color: isDragging ? '#007bff' : '#999',
                            marginBottom: 15
                          }}
                        ></i>
                        <p style={{ fontSize: "16px", color: isDragging ? '#007bff' : '#666', marginBottom: 10 }}>
                          {isDragging ? 'Solte o ficheiro aqui' : 'Arraste e solte o ficheiro CSV aqui ou clique para selecionar'}
                        </p>
                        <p style={{ fontSize: "12px", color: "#999" }}>
                          Formatos suportados: .csv
                        </p>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <button 
                          className="btn btn-secondary" 
                          onClick={() => this.setState({ showImportModal: false, isDragging: false })}
                        >
                            Cancelar
                          </button>
                        <button 
                          className="btn btn-primary" 
                          onClick={this.handleFileSelect}
                        >
                          Selecionar Ficheiro
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                {/* Modal de mapeamento de colunas CSV */}
                {showMappingModal && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100vw",
                      height: "100vh",
                      background: "rgba(0,0,0,0.3)",
                      zIndex: 1001,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "auto"
                    }}
                    onClick={(e) => {
                      if (e.target === e.currentTarget) {
                        this.handleMappingCancel();
                      }
                    }}
                  >
                    <div
                      style={{
                        background: "#fff",
                        padding: 20,
                        borderRadius: 8,
                        minWidth: 600,
                        maxWidth: "90vw",
                        maxHeight: "90vh",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                        overflow: "auto"
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h4 style={{ marginTop: 0 }}>Mapear Colunas do CSV</h4>
                      <p style={{ fontSize: "14px", color: "#666", marginBottom: 20 }}>
                        Mapeie cada coluna do ficheiro CSV para o campo correspondente na base de dados.
                      </p>
                      {codeConflicts.length > 0 && (
                        <div style={{
                          marginBottom: 20,
                          padding: 15,
                          backgroundColor: "#fff3cd",
                          border: "1px solid #ffc107",
                          borderRadius: "4px",
                          fontSize: "14px"
                        }}>
                          <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                            <i className="fas fa-exclamation-triangle" style={{ color: "#856404", marginRight: 10, fontSize: "18px" }}></i>
                            <strong style={{ color: "#856404" }}>
                              {codeConflicts.length} Conflito(s) de Código Detectado(s)
                            </strong>
                </div>
                          <p style={{ color: "#856404", marginBottom: 10 }}>
                            Os seguintes códigos já existem na base de dados e serão <strong>atualizados</strong>:
                          </p>
                          <div style={{
                            maxHeight: "150px",
                            overflow: "auto",
                            backgroundColor: "#fff",
                            padding: "10px",
                            borderRadius: "4px",
                            fontSize: "12px"
                          }}>
                            {codeConflicts.map((conflict, index) => (
                              <div key={index} style={{ marginBottom: "5px", padding: "5px", borderBottom: "1px solid #f0f0f0" }}>
                                <strong>Linha {conflict.line}:</strong> Código <code style={{ backgroundColor: "#f8f9fa", padding: "2px 6px", borderRadius: "3px" }}>{conflict.code}</code>
              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      <div style={{ marginBottom: 20, maxHeight: "400px", overflow: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                              <th style={{ padding: "10px", textAlign: "left", border: "1px solid #ddd" }}>
                                Coluna do CSV
                              </th>
                              <th style={{ padding: "10px", textAlign: "left", border: "1px solid #ddd" }}>
                                Exemplo de valor
                              </th>
                              <th style={{ padding: "10px", textAlign: "left", border: "1px solid #ddd" }}>
                                Mapear para campo
                              </th>
                  </tr>
                </thead>
                <tbody>
                            {csvColumns.map((column, index) => {
                              const sampleValue = csvData.length > 0 && csvData[0][column] 
                                ? (String(csvData[0][column]).length > 30 
                                  ? String(csvData[0][column]).substring(0, 30) + '...' 
                                  : String(csvData[0][column]))
                                : '(vazio)';
                              const isAutoMapped = this.state.autoMappedColumns.includes(column);
                              return (
                                <tr 
                                  key={index}
                                  style={{
                                    backgroundColor: isAutoMapped ? '#e8f5e9' : '#fff',
                                    borderLeft: isAutoMapped ? '3px solid #4caf50' : 'none'
                                  }}
                                >
                                  <td style={{ 
                                    padding: "10px", 
                                    border: "1px solid #ddd", 
                                    fontWeight: "500",
                                    position: "relative"
                                  }}>
                                    {isAutoMapped && (
                                      <span 
                                        style={{
                                          position: "absolute",
                                          left: "-10px",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          fontSize: "16px",
                                          color: "#4caf50"
                                        }}
                                        title="Pré-selecionado automaticamente"
                                      >
                                        ✓
                                      </span>
                                    )}
                                    {column}
                                  </td>
                                  <td style={{ padding: "10px", border: "1px solid #ddd", fontSize: "12px", color: "#666", fontStyle: "italic" }}>
                                    {sampleValue}
                                  </td>
                                  <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                    <select
                                      value={columnMapping[column] || ''}
                                      onChange={(e) => {
                                        this.handleMappingChange(column, e.target.value);
                                        // Remover da lista de auto-mapeados se alterar
                                        if (isAutoMapped && e.target.value !== columnMapping[column]) {
                                          this.setState(prevState => ({
                                            autoMappedColumns: prevState.autoMappedColumns.filter(col => col !== column)
                                          }));
                                        }
                                      }}
                                      style={{
                                        width: "100%",
                                        padding: "8px",
                                        borderRadius: "4px",
                                        border: isAutoMapped ? "1px solid #4caf50" : "1px solid #ddd",
                                        backgroundColor: isAutoMapped ? '#f1f8f4' : '#fff'
                                      }}
                                    >
                                      {availableFields.map((field, fieldIndex) => (
                                        <option key={fieldIndex} value={field.value}>
                                          {field.label}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      {this.state.autoMappedColumns.length > 0 && (
                        <div style={{ 
                          marginBottom: 20, 
                          padding: 10, 
                          backgroundColor: "#e8f5e9", 
                          borderRadius: "4px",
                          fontSize: "12px",
                          color: "#2e7d32"
                        }}>
                          <i className="fas fa-info-circle" style={{ marginRight: 8 }}></i>
                          <strong>{this.state.autoMappedColumns.length}</strong> coluna(s) foram pré-selecionadas automaticamente (marcadas com ✓ e fundo verde).
                        </div>
                      )}
                      <div style={{ 
                        marginTop: 20, 
                        padding: 15, 
                        backgroundColor: "#f8f9fa", 
                        borderRadius: "4px",
                        fontSize: "12px"
                      }}>
                        <strong>Dica:</strong> Se uma coluna não corresponder a nenhum campo, selecione "Ignorar coluna".
                      </div>
                      {!Object.values(columnMapping).includes('nome_1') && (
                        <div style={{ 
                          marginTop: 15, 
                          padding: 15, 
                          backgroundColor: "#ffebee", 
                          border: "1px solid #d32f2f",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: "#c62828"
                        }}>
                          <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }}></i>
                          <strong>Atenção:</strong> É <strong>obrigatório</strong> mapear pelo menos uma coluna para o campo <strong>Nome</strong>.
                        </div>
                      )}
                      {!Object.values(columnMapping).includes('codigo') && (
                        <div style={{ 
                          marginTop: 15, 
                          padding: 15, 
                          backgroundColor: "#e3f2fd", 
                          border: "1px solid #2196f3",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: "#1565c0"
                        }}>
                          <i className="fas fa-info-circle" style={{ marginRight: 8 }}></i>
                          <strong>Nota:</strong> Nenhuma coluna foi mapeada para o campo <strong>Código</strong>. 
                          Todos os clientes serão <strong>adicionados como novos</strong> com códigos gerados automaticamente.
                        </div>
                      )}
                      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
                        <button 
                          className="btn btn-secondary" 
                          onClick={this.handleMappingCancel}
                        >
                          Cancelar
                        </button>
                        <button 
                          className="btn btn-primary" 
                          onClick={this.handleMappingConfirm}
                          disabled={!Object.values(columnMapping).includes('nome_1')}
                          style={{
                            opacity: !Object.values(columnMapping).includes('nome_1') ? 0.5 : 1,
                            cursor: !Object.values(columnMapping).includes('nome_1') ? 'not-allowed' : 'pointer'
                          }}
                        >
                          Importar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div className="clientes-filters-grid">
                  <div className="clientes-filter-item">
                    <label className="clientes-filter-label">Pesquisa</label>
                      <Input
                        inputType={"text"}
                        name={"search"}
                        value={search}
                        placeholder="pesquisa..."
                        handleChange={(e) => this.filterData(e.target.value)}
                      />
                  </div>
                  <div className="clientes-filter-item">
                    <label className="clientes-filter-label">Estado</label>
                      <AutoComplete
                        name={"status"}
                        value={status} 
                        handleChange={this.handleChange}
                        options={allStatus}
                      />
                  </div>
                  {allSegmentacoes.length > 1 && (
                    <div className="clientes-filter-item">
                      <label className="clientes-filter-label">Segmentação</label>
                      <AutoComplete
                        name={"segmentacao"}
                        value={segmentacao} 
                        handleChange={this.handleChange}
                        options={allSegmentacoes}
              />
            </div>
                  )}
                  {allZonas.length > 1 && (
                    <div className="clientes-filter-item">
                      <label className="clientes-filter-label">Localização</label>
                      <AutoComplete
                        name={"zona"}
                        value={zona} 
                        handleChange={this.handleChange}
                        options={allZonas}
                      />
                    </div>
                  )}
                </div>
              </div>
              
              {/* Vista Mobile - Cards */}
              <div className="clientes-cards-list">
                {table.loading ? (
                  <div style={{ textAlign: "center", padding: "40px" }}>
                    <p>A carregar clientes...</p>
                  </div>
                ) : paginatedCustomers.length === 0 ? (
                  <div className="clientes-empty-state">
                    <p>Nenhum cliente encontrado.</p>
                  </div>
                ) : (
                  <>
                    {paginatedCustomers.map((customer) => (
                      <div key={customer.codigo} className="cliente-card">
                        <div className="cliente-card-header">
                          <div className="cliente-card-image-name">
                            <img
                              src={customer.fotografia || 'https://eposgestofinal.com/site/images/profile.jpg'}
                              alt={customer.nome_1 || 'Cliente'}
                              className="cliente-card-image"
                              onError={(e) => {
                                e.target.src = 'https://eposgestofinal.com/site/images/profile.jpg';
                              }}
                            />
                            <div className="cliente-card-info-main">
                              <div className="cliente-card-name">{customer.nome_1 || '-'}</div>
                              <div className="cliente-card-code">Código: {customer.codigo || '-'}</div>
                            </div>
                          </div>
                          <div className="cliente-card-status">
                            {customer.inativo === 't' ? (
                              <span className="badge badge-danger">INATIVO</span>
                            ) : (
                              <span className="badge badge-success">ATIVO</span>
                            )}
                          </div>
                        </div>
                        <div className="cliente-card-info">
                          <div className="cliente-card-row">
                            <span className="cliente-card-label">Morada:</span>
                            <span className="cliente-card-value">{customer.morada_1 || '-'}</span>
                          </div>
                          {customer.morada_2 && (
                            <div className="cliente-card-row">
                              <span className="cliente-card-label">Localidade:</span>
                              <span className="cliente-card-value">{customer.morada_2}</span>
                            </div>
                          )}
                          <div className="cliente-card-data-grid">
                            {customer.telefone && (
                              <div className="cliente-card-data-item">
                                <span className="cliente-card-label">Telefone</span>
                                <span className="cliente-card-value">{customer.telefone}</span>
                              </div>
                            )}
                            {customer.telemovel && (
                              <div className="cliente-card-data-item">
                                <span className="cliente-card-label">Telemóvel</span>
                                <span className="cliente-card-value">{customer.telemovel}</span>
                              </div>
                            )}
                            {customer.email && (
                              <div className="cliente-card-data-item">
                                <span className="cliente-card-label">Email</span>
                                <span className="cliente-card-value">{customer.email}</span>
                              </div>
                            )}
                            {customer.nif && (
                              <div className="cliente-card-data-item">
                                <span className="cliente-card-label">NIF</span>
                                <span className="cliente-card-value">{customer.nif}</span>
                              </div>
                            )}
                          </div>
                          {customer.segmentacoes && customer.segmentacoes !== 'Nenhuma' && (
                            <div className="cliente-card-row">
                              <span className="cliente-card-label">Segmentações:</span>
                              <span className="cliente-card-value">{customer.segmentacoes}</span>
                            </div>
                          )}
                          {customer.zona && customer.zona !== 'Nenhuma' && (
                            <div className="cliente-card-row">
                              <span className="cliente-card-label">Localização:</span>
                              <span className="cliente-card-value">{customer.zona}</span>
                            </div>
                          )}
                        </div>
                        <div className="cliente-card-actions">
                          <div
                            className="cliente-action-btn"
                            onClick={() => history.push(`/clientes/${customer.codigo}`)}
                          >
                            <MdVisibility />
                            <span>Ver</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>

              {/* Vista Desktop - Tabela */}
              <div className="clientes-grid-desktop">
                {table.loading ? (
                  <div style={{ textAlign: "center", padding: "40px" }}>
                    <p>A carregar clientes...</p>
                  </div>
                ) : paginatedCustomers.length === 0 ? (
                  <div className="clientes-empty-state">
                    <p>Nenhum cliente encontrado.</p>
                  </div>
                ) : (
                  <>
                    <div className="clientes-table-desktop">
                      <div className="clientes-table-header">
                        <div className="clientes-table-col-client">
                          <span className="clientes-table-header-label">CLIENTE</span>
                        </div>
                        <div className="clientes-table-col-address">
                          <span className="clientes-table-header-label">MORADA</span>
                        </div>
                        <div className="clientes-table-col-phone">
                          <span className="clientes-table-header-label">TELEFONE</span>
                        </div>
                        <div className="clientes-table-col-mobile">
                          <span className="clientes-table-header-label">TELEMÓVEL</span>
                        </div>
                        <div className="clientes-table-col-email">
                          <span className="clientes-table-header-label">EMAIL</span>
                        </div>
                        {table.columns.some(col => col.accessor === 'segmentacoes') && (
                          <div className="clientes-table-col-segmentation">
                            <span className="clientes-table-header-label">SEGMENTAÇÕES</span>
                          </div>
                        )}
                        {table.columns.some(col => col.accessor === 'zona') && (
                          <div className="clientes-table-col-zone">
                            <span className="clientes-table-header-label">LOCALIZAÇÃO</span>
                          </div>
                        )}
                        <div className="clientes-table-col-actions">
                          <span className="clientes-table-header-label">AÇÕES</span>
                        </div>
                      </div>
                      {paginatedCustomers.map((customer) => (
                        <div key={customer.codigo} className="clientes-table-row">
                          <div className="clientes-table-col-client">
                            <div className="cliente-row-client-container">
                              <div className="cliente-row-status">
                                {customer.inativo === 't' ? (
                                  <span className="badge badge-danger">INATIVO</span>
                                ) : (
                                  <span className="badge badge-success">ATIVO</span>
                                )}
                              </div>
                              <img
                                src={customer.fotografia || 'https://eposgestofinal.com/site/images/profile.jpg'}
                                alt={customer.nome_1 || 'Cliente'}
                                className="cliente-row-image"
                                onError={(e) => {
                                  e.target.src = 'https://eposgestofinal.com/site/images/profile.jpg';
                                }}
                              />
                              <div className="cliente-row-client-info">
                                <span className="cliente-row-code">{customer.codigo || '-'}</span>
                                <span className="cliente-row-name">{customer.nome_1 || '-'}</span>
                                {customer.nif && (
                                  <span className="cliente-row-nif">NIF: {customer.nif}</span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="clientes-table-col-address">
                            <span className="cliente-row-value">{customer.morada_1 || '-'}</span>
                          </div>
                          <div className="clientes-table-col-phone">
                            <span className="cliente-row-value">{customer.telefone || '-'}</span>
                          </div>
                          <div className="clientes-table-col-mobile">
                            <span className="cliente-row-value">{customer.telemovel || '-'}</span>
                          </div>
                          <div className="clientes-table-col-email">
                            <span className="cliente-row-value">{customer.email || '-'}</span>
                          </div>
                          {table.columns.some(col => col.accessor === 'segmentacoes') && (
                            <div className="clientes-table-col-segmentation">
                              <span className="cliente-row-value">
                                {customer.segmentacoes && customer.segmentacoes !== 'Nenhuma' ? customer.segmentacoes : '-'}
                              </span>
                            </div>
                          )}
                          {table.columns.some(col => col.accessor === 'zona') && (
                            <div className="clientes-table-col-zone">
                              <span className="cliente-row-value">
                                {customer.zona && customer.zona !== 'Nenhuma' ? customer.zona : '-'}
                              </span>
                            </div>
                          )}
                          <div className="clientes-table-col-actions">
                            <div className="cliente-row-actions">
                              <button
                                className="cliente-action-btn-desktop"
                                onClick={() => history.push(`/clientes/${customer.codigo}`)}
                                title="Ver Cliente"
                              >
                                <MdVisibility />
                                <span>Ver</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>

            {/* Paginação */}
            {filteredCustomers.length > 0 && (
              <div className="clientes-pagination">
                <div className="clientes-pagination-info">
                  <span>
                    Mostrando {startIndex + 1} - {Math.min(endIndex, filteredCustomers.length)} de {filteredCustomers.length} clientes
                  </span>
                  <div className="clientes-pagination-items-per-page">
                    <label htmlFor="itemsPerPage">Itens por página:</label>
                    <select
                      id="itemsPerPage"
                      value={itemsPerPage}
                      onChange={this.handleItemsPerPageChange}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>
                </div>
                <div className="clientes-pagination-controls">
                  <button
                    className="clientes-pagination-btn"
                    onClick={() => this.handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                  <span className="clientes-pagination-page-info">
                    Página {currentPage} de {totalPages}
                  </span>
                  <button
                    className="clientes-pagination-btn"
                    onClick={() => this.handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Seguinte
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <Modal modifier="big" id="newcustomer" />
        
        {/* Tooltip for segmentations */}
        {tooltip.show && (
          <div
            style={{
              position: 'fixed',
              top: tooltip.y,
              left: tooltip.x,
              transform: 'translateX(-50%) translateY(-100%)',
              backgroundColor: '#1f2937',
              color: 'white',
              padding: '12px 16px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              zIndex: 1000,
              maxWidth: '300px',
              minWidth: '200px'
            }}
          >
            <div style={{ 
              fontSize: '12px', 
              fontWeight: '600', 
              marginBottom: '8px',
              color: '#9ca3af'
            }}>
              Segmentações:
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
              {tooltip.content.map((seg, index) => (
                <span
                  key={index}
                  style={{
                    display: 'inline-block',
                    backgroundColor: seg.color || '#374151',
                    color: seg.color && this.isDarkColor(seg.color) ? '#ffffff' : '#000000',
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontSize: '11px',
                    fontWeight: '500'
                  }}
                >
                  {seg.nome || `Segmentação ${seg.idsegmentacao}`}
                </span>
              ))}
            </div>
            {/* Arrow pointing down */}
            <div
              style={{
                position: 'absolute',
                bottom: '-6px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 0,
                height: 0,
                borderLeft: '6px solid transparent',
                borderRight: '6px solid transparent',
                borderTop: '6px solid #1f2937'
              }}
            />
          </div>
        )}

        {/* Tooltip for zones */}
        {zoneTooltip.show && zoneTooltip.zone && (
          <div
            style={{
              position: 'fixed',
              top: zoneTooltip.y,
              left: zoneTooltip.x,
              transform: 'translateX(-50%) translateY(-100%)',
              backgroundColor: '#1f2937',
              color: 'white',
              padding: '8px',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              zIndex: 1000,
              width: '200px',
              height: '200px'
            }}
          >
            <div style={{ 
              fontSize: '12px', 
              fontWeight: '600', 
              marginBottom: '8px',
              color: '#9ca3af',
              textAlign: 'center'
            }}>
              {zoneTooltip.zone.name}
            </div>
            <div style={{ width: '100%', height: '160px', borderRadius: '4px', overflow: 'hidden' }}>
              <Map
                center={this.getZoneBounds(zoneTooltip.zone).center}
                bounds={this.getZoneBounds(zoneTooltip.zone).bounds}
                style={{ height: '100%', width: '100%' }}
                zoomControl={false}
                attributionControl={false}
                dragging={false}
                touchZoom={false}
                doubleClickZoom={false}
                scrollWheelZoom={false}
                boxZoom={false}
                keyboard={false}
                boundsOptions={{
                  padding: [10, 10]
                }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {zoneTooltip.zone.coordinates && Array.isArray(zoneTooltip.zone.coordinates) && (
                  <Polygon
                    positions={zoneTooltip.zone.coordinates}
                    pathOptions={{
                      fillColor: zoneTooltip.zone.color?.fill || zoneTooltip.zone.color || '#3b82f6',
                      fillOpacity: 0.6,
                      color: zoneTooltip.zone.color?.stroke || zoneTooltip.zone.color || '#1d4ed8',
                      weight: 2
                    }}
                  />
                )}
                <Marker
                  position={this.getZoneBounds(zoneTooltip.zone).center}
                  icon={L.divIcon({
                    className: 'zone-center-marker',
                    html: '<div style="background: #ef4444; width: 8px; height: 8px; border-radius: 50%; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>',
                    iconSize: [12, 12],
                    iconAnchor: [6, 6]
                  })}
                />
              </Map>
            </div>
            {/* Arrow pointing down */}
            <div
              style={{
                position: 'absolute',
                bottom: '-6px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 0,
                height: 0,
                borderLeft: '6px solid transparent',
                borderRight: '6px solid transparent',
                borderTop: '6px solid #1f2937'
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withCookies(withRouter(Page));
